<template>
  <div
    class="w-full flex flex-col text-gray-900 overflow-hidden"
    style="background-color: #faf7f2"
  >
    <div class="w-full h-full mx-auto">
      <!-- :class="{ 'max-w-screen-sm': $route?.name !== 'home' }" -->
      <router-view />
    </div>

    <AppLoader />

    <TheAuth v-if="ui.authModal.isVisible" />

    <TheConfetti v-if="ui.confetti.isVisible && !ui.demoTopicModal.isVisible" />

    <WelcomeModal
      v-if="welcomeModal.isVisible"
      @close="() => (welcomeModal.isVisible = false)"
    />

    <!-- <PaymentTariffsModal
      v-if="ui.tariffsModal.isVisible"
      @close="() => setUiTariffsModalIsVisible(false)"
    /> -->

    <PaymentPaywallModal
      v-if="ui.paywallModal.isVisible"
      @close="() => setUiPaywallModalIsVisible(false)"
    />

    <!-- <PaymentNewPaywallModal
      v-if="ui.newPaywallModal.isVisible"
      @close="() => setUiNewPaywallModalIsVisible(false)"
    /> -->

    <DemoTopicModal
      v-if="ui.demoTopicModal.isVisible"
      :section-slug="ui.demoTopicModal.sectionSlug"
      :topic-slug="ui.demoTopicModal.topicSlug"
      @close="() => setUiDemoTopicModal({ isVisible: false })"
    />

    <div class="fixed pointer-events-none z-[-99999] opacity-0">
      <img src="/icons/star.png" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import { detectDefaultLocale } from '@/utils/locale'

import AppLoader from '@/components/App/AppLoader.vue'
import TheAuth from '@/components/Auth/TheAuth.vue'

import TheConfetti from '@/components/Confetti/TheConfetti.vue'
// import PaymentTariffsModal from '@/components/Payment/PaymentTariffsModal.vue'
import WelcomeModal from '@/components/Welcome/WelcomeModal.vue'
import PaymentPaywallModal from '@/components/Payment/PaymentPaywallModal.vue'
// import PaymentNewPaywallModal from '@/components/Payment/PaymentNewPaywallModal.vue'
import DemoTopicModal from '@/components/Demo/DemoTopicModal.vue'

export default {
  name: 'TheApp',

  components: {
    AppLoader,
    TheAuth,
    TheConfetti,
    // PaymentTariffsModal,
    WelcomeModal,
    PaymentPaywallModal,
    // PaymentNewPaywallModal,
    DemoTopicModal
  },

  data: () => ({
    welcomeModal: {
      isVisible: false
    }
  }),

  computed: {
    ...mapState('ui', ['ui'])
  },

  watch: {
    '$route.query.action': {
      immediate: true,
      handler(value) {
        if (!value) return

        if (value === 'open-login') {
          this.setUiAuthModal({ isVisible: true })
          this.$router.replace({
            query: { ...this.$route.query, action: undefined }
          })
        }

        if (value === 'open-registration') {
          this.setUiAuthModal({
            isVisible: true,
            componentCode: 'registration'
          })
          this.$router.replace({
            query: { ...this.$route.query, action: undefined }
          })
        }

        if (value === 'welcome') {
          this.welcomeModal.isVisible = true
          this.$router.replace({
            query: { ...this.$route.query, action: undefined }
          })
        }

        if (value === 'open-tariffs') {
          this.setUiTariffsModalIsVisible(true)
          this.$router.replace({
            query: { ...this.$route.query, action: undefined }
          })
        }
      }
    }
  },

  async created() {
    this.fetchHappyUsers()
    this.checkIsUserAuthorized()
    // this.checkPendingOrder()

    const defaultLocale = await detectDefaultLocale()
    this.setLocale(defaultLocale)
  },

  mounted() {
    this.disabledDoubleClickToZoomOnMobile()
    this.showIconsAfterFontsAreLoaded()
  },

  methods: {
    ...mapActions('ui', {
      fetchHappyUsers: 'FETCH_HAPPY_USERS'
    }),
    ...mapActions('auth', {
      checkIsUserAuthorized: 'CHECK_IS_USER_AUTHORIZED'
    }),
    ...mapMutations('ui', {
      setUiAuthModal: 'SET_UI_AUTH_MODAL',
      setUiTariffsModalIsVisible: 'SET_UI_TARIFFS_MODAL_IS_VISIBLE',
      setUiPaywallModalIsVisible: 'SET_UI_PAYWALL_MODAL_IS_VISIBLE',
      // setUiNewPaywallModalIsVisible: 'SET_UI_NEW_PAYWALL_MODAL_IS_VISIBLE',
      setUiDemoTopicModal: 'SET_UI_DEMO_TOPIC_MODAL'
    }),
    ...mapMutations('locale', {
      setLocale: 'SET_LOCALE'
    }),

    disabledDoubleClickToZoomOnMobile() {
      document.addEventListener('dblclick', e => e.preventDefault(), {
        passive: false
      })
    },

    showIconsAfterFontsAreLoaded() {
      document.querySelectorAll('.BaseIcon').forEach(icon => {
        icon.style.visibility = 'hidden'
      })

      document.fonts.ready.then(() => {
        document.querySelectorAll('.BaseIcon').forEach(icon => {
          icon.style.visibility = 'visible'
        })
      })
    }
  }
}
</script>
